<template>
  <div class="">
    <div class="common-title">融资信息</div>
    <div class="page-main no-shadow" style="padding-bottom:6px;">
      <a-form-model
        class="common-form-inline"
        :model="fintData"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-row>
          <a-col span="12" class="text-item-box">
            <span class="text-item">银行名称：</span
            ><span class="text-val">{{ fintData.tenantNm }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">申请日期：</span
            ><span class="text-val">{{
              fintData.applyDate | dateFormat("YYYY-mm-dd")
            }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">申请编号：</span
            ><span class="text-val">{{ fintData.fncJrnlId }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">意向放款日期：</span
            ><span class="text-val"
              >{{ fintData.expectDate | dateFormat("YYYY-mm-dd") }} </span
            ><span class="text-color-orange text-size-12"> 以实际放款为准</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">资金用途：</span
            ><span class="text-val">
              <span v-if="fintData.opin">{{ fintData.opin }}</span>
              <span v-else>{{
                fintData.cptlTpCd | dictFilter(dict.useOfFunds)
              }}</span>
            </span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">到期日期：</span
            ><span class="text-val">{{
              fintData.goldList &&
                fintData.goldList[0].exDay | dateFormat("YYYY-mm-dd")
            }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">还款方式：</span
            ><span class="text-val">{{
              fintData.instmRepyTpCd | rpMdCdTrans
            }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">融资金额：</span
            ><span class="text-val">{{ fintData.thsFncAmt | splitK }} 元</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">利率(%)：</span
            ><span class="text-val">{{ fintData.yrRate || 0 }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">预估利息：</span
            ><span class="text-val">{{ fintData.interest | splitK }} 元</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">融资手续费率(%)：</span
            ><span class="text-val">{{ fintData.financingFeeRatio || 0 }}</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">预估融资手续费：</span
            ><span class="text-val">{{ fintData.fee | splitK }} 元</span>
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">平台服务费：</span
            ><span class="text-val"
              >{{ fintData.platformInt | splitK }} 元</span
            >
          </a-col>
          <a-col span="12" class="text-item-box">
            <span class="text-item">合计金额：</span
            ><span class="text-val"
              ><span class="fin-num">{{ fintData.totalAmt | splitK }}</span>
              元 </span
            ><span class="text-color-orange text-size-12"> 以实际放款为准</span>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <div class="common-title">祺信信息</div>
    <div class="table-common" style="margin-bottom:16px;">
      <a-table
        class="no-scroll"
        :pagination="false"
        size="middle"
        :columns="columns"
        :row-key="record => record.id"
        :data-source="goldList"
        bordered
        :locale="{ emptyText: '暂无数据' }"
      >
        <template slot="gldAmt" slot-scope="text">{{ text | splitK }}</template>
        <template slot="exDay" slot-scope="text">{{
          text | dateFormat("YYYY-mm-dd")
        }}</template>
        <template slot="canBeModified" slot-scope="text">{{
          fatherCheckGold.canBeModified | gbCbmTrans
        }}</template>
        <template slot="oper" slot-scope="text, record">
          <a @click="openGoldDetail(record)">详情</a>
        </template>
      </a-table>
    </div>

    <div class="common-title">贸易资料</div>
    <div class="table-common" style="margin-bottom:16px;">
      <a-table
        size="middle"
        :pagination="false"
        :columns="tradeBackgroundColumns"
        :row-key="record => record.id"
        :data-source="tradeBackgroundData"
        bordered
        :locale="{ emptyText: '暂无数据' }"
      >
        <template slot="invoiceType" slot-scope="text">
          {{ text | invoiceTypeFilter }}
        </template>
        <template slot="invoiceNumber" slot-scope="text, record">
          <a @click="toInvoiceInfo(record)">{{ text }}</a>
        </template>
        <template slot="billTime" slot-scope="text">
          {{ text | dateFormat("YYYY-mm-dd") }}
        </template>
        <template slot="invoiceAmountWithVat" slot-scope="text">
          {{ text | splitK }}
        </template>
        <template slot="contractNo" slot-scope="text, record">
          <a v-if="text" @click="contractInfoOpen(record)">{{ text }}</a>
          <span v-else>--</span>
        </template>
        <template slot="otherFile" slot-scope="text, record">
          <a v-if="record.uploaded" @click="toDeliveryCreate(record)">查看</a>
          <span v-else>--</span>
        </template>
      </a-table>
    </div>

    <!-- 其他资料 -->
    <div v-show="relatedFileContents.length > 0">
      <div class="common-title">其他资料</div>
      <div class="page-main no-shadow">
        <div
          class="spaceBetween file-item"
          v-for="(file, index) in relatedFileContents"
          :key="index"
        >
          <div class="spaceLeft">
            <div class="file-title small">
              <span class="text-color-orange" v-if="file.required">*</span>
              {{ file.name }}
            </div>
            <div class="text-color-blue">
              <fileUpload
                accept=".pdf,.PDF"
                className="fnc-file"
                ref="fncRelatedFile"
                :paramObj.sync="relatedFileParam"
                @uploadOk="uploadOkRelated($event, file)"
                @beforeFileUpload="beforeUploadRelated($event, file, index)"
                :removeaction="true"
                name="file"
              />
            </div>
          </div>
          <div style="width:30%">
            <a
              href="javascript:void(0)"
              @click="fileDownload(file.template.url)"
              v-if="file.template"
              >{{ file.template.name }}</a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="common-title">收款账户</div>
    <div class="page-main no-shadow">
      <a-row>
        <a-col span="12" class="text-item-box">
          <span class="text-item">账户名称：</span
          ><span class="text-val">{{ bindingAccountData.cstNm }}</span>
        </a-col>
        <a-col span="12" class="text-item-box">
          <span class="text-item">开户银行：</span
          ><span class="text-val">{{ bindingAccountData.accBlngBnk }}</span>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="12" class="text-item-box">
          <span class="text-item">账户账号：</span
          ><span class="text-val">{{ bindingAccountData.accNo }}</span>
        </a-col>
        <a-col span="12" class="text-item-box">
          <span class="text-item">大额行号：</span
          ><span class="text-val">{{ bindingAccountData.largeBankNo }}</span>
        </a-col>
      </a-row>
    </div>

    <!-- 上海银行 -->
    <div class="common-title">相关协议</div>
    <div
      class="page-main no-shadow"
      style="margin-bottom:8px;"
      v-show="dict.bankListMap[feeData.bank] == 'shanghai'"
    >
      <div class="text-color-orange">
        温馨提示：您在上银企业银行APP已签署如下协议。请在上银企业银行APP下载对应协议（pdf格式）并上传。
      </div>
      <div
        class="spaceLeft file-item"
        v-for="(file, index) in fileList"
        :key="index"
      >
        <div class="file-title">
          <span class="text-color-orange">*</span>《{{ file.artcTtl }}》
        </div>
        <div class="text-color-blue">
          <fileUpload
            accept=".pdf,.PDF"
            className="fnc-file"
            ref="fncFile"
            :paramObj.sync="fileParam"
            @uploadOk="uploadOk($event, file)"
            @handleFileRemove="removeFile($event, file)"
            :removeaction="true"
            :disabled="fileDisabled"
            :showList="showFileList(index)"
            name="file"
          />
        </div>
      </div>
    </div>

    <!-- 线上签署的相关协议 -->
    <div
      class="page-main no-shadow"
      style="margin-bottom:8px;"
      v-show="fileListOnline.length > 0"
    >
      <div
        class="spaceLeft file-item"
        v-for="(file, index) in fileListOnline"
        :key="index"
      >
        <div class="file-title">
          <span class="text-color-orange">*</span>
          <a @click="showfileOnline(file)">《{{ file.artcTtl }}》</a>
        </div>
      </div>
    </div>

    <a-checkbox v-model="isAgreeFile" v-if="isShowAgree">
      <span :class="{ 'agree-active': agreeActive && !isAgreeFile }"
        >已阅读，并同意以上所有协议</span
      >
    </a-checkbox>

    <a-modal
      width="400px"
      title="祺信融资确认"
      :visible="modalShowPay"
      :maskClosable="false"
      :footer="null"
      @cancel="modalShowPay = false"
    >
      <financePasswordModal
        v-if="modalShowPay"
        :modalData="modalData"
        @ok="modalOk"
        @cancel="modalCancel"
      ></financePasswordModal>
    </a-modal>
    <!-- 祺信详情弹窗 -->
    <financingGoldDetailModel
      ref="finGoldPageDialog"
      :parentData.sync="curRowGold"
    />

    <!-- 查看弹窗 -->
    <invoiceInfo ref="invoiceInfo" :readonly="true" :info.sync="curRow" />
    <!-- 查看合同 -->
    <contractDialog
      title="匹配合同详情"
      ref="contractInfo"
      :readonly="true"
      :info.sync="curRow"
    />
    <!-- 相关附件 -->
    <relatedFileDialog ref="relatedFileDialog" />

    <!-- 查看线上的相关协议 -->
    <serviceView ref="serviceView" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { invoiceList } from "@/api/payable.js";
import {
  submitFormAll,
  finSaveTradeBackground,
  queryAgreementList,
  saveOrUpdateBizLawTxtTrans,
  deleteLawTxtTrans,
  getFncLawText
} from "@/api/sell.js";
import { bindingAccountList } from "@/api/customer.js";
import { fileSaveAPI } from "@/api/file.js";
import financePasswordModal from "@/pages/circulation/gold-financing/finance-password-modal";
import financingGoldDetailModel from "@/pages/circulation/gold-financing/financing-gold-detail-model";
import invoiceInfo from "@/pages/bill-manage/receivable/invoice-info-dialog";
import contractDialog from "@/pages/bill-manage/receivable/contract-info-dialog";
import relatedFileDialog from "@/pages/bill-manage/receivable/related-file-dialog";
import serviceView from "@/components/sign/serviceView";
export default {
  props: {
    params: {
      type: [Array, Object]
    }
  },
  components: {
    financePasswordModal,
    financingGoldDetailModel,
    invoiceInfo,
    contractDialog,
    relatedFileDialog,
    serviceView
  },
  data() {
    return {
      tableData: [],
      formData: {},
      feeData: {},
      fintData: {},
      goldList: [],
      columns: [
        {
          title: "祺信编号",
          dataIndex: "gldId"
        },
        {
          title: "开立方",
          dataIndex: "estbNm"
        },
        {
          title: "祺信金额(元)",
          dataIndex: "gldAmt",
          scopedSlots: { customRender: "gldAmt" }
        },
        {
          title: "到期日期",
          dataIndex: "exDay",
          scopedSlots: { customRender: "exDay" }
        },
        {
          title: "变更状态",
          dataIndex: "canBeModified ",
          scopedSlots: { customRender: "canBeModified" }
        },
        {
          title: "上级祺信",
          dataIndex: "oriGldId"
        },
        {
          title: "上级祺信流转方",
          dataIndex: "oriGldNm"
        },
        {
          title: "操作",
          dataIndex: "oper",
          scopedSlots: { customRender: "oper" }
        }
      ],
      invContracLoading: false,
      tradeBackgroundData: [],
      tradeBackgroundColumns: [
        {
          title: "买方名称",
          dataIndex: "buryName",
          width: 140,
          ellipsis: true
        },
        {
          title: "发票类型",
          dataIndex: "invoiceType",
          scopedSlots: { customRender: "invoiceType" },
          width: 90
        },
        {
          title: "发票号码",
          dataIndex: "invoiceNumber",
          scopedSlots: { customRender: "invoiceNumber" },
          width: 120
        },
        {
          title: "开票日期",
          dataIndex: "billTime",
          scopedSlots: { customRender: "billTime" },
          width: 120
        },
        {
          title: "含税金额(元)",
          dataIndex: "invoiceAmountWithVat",
          scopedSlots: { customRender: "invoiceAmountWithVat" },
          width: 120
        },
        {
          title: "合同编号",
          dataIndex: "contractNo",
          scopedSlots: { customRender: "contractNo" },
          width: 100
        },
        {
          title: "相关附件",
          dataIndex: "otherFile",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "otherFile" }
        }
      ],
      curRowGold: null,
      curRowTradeBg: null,
      isAutoWithdraw: "1",
      bindingAccountData: {},
      isAgreeFile: false,
      modalShowPay: false,
      modalData: {},
      fatherCheckGold: {},

      // 相关协议
      fileDisabled: false,
      fileList: [],
      fileParam: {
        app: "portal-pc",
        module: "payable",
        user: this.$store.getters["home/getUserHeader"].realname,
        tblBlId: "",
        mdlId: "payable"
      },
      agreeActive: false,
      curRow: null,

      // 相关资料
      relatedFileContents: [],
      relatedFileParam: {
        app: "portal-pc",
        module: "fnc",
        user: this.$store.getters["home/getUserHeader"].realname,
        tblBlId: undefined,
        mdlId: "fnc",
        atchNm: undefined,
        fileTpCd: 2,
        fileSubTpCd: undefined,
        expdId: undefined //对应哪类的文件
      },

      // 相关协议线上签署
      fileListOnline: []
    };
  },
  computed: {
    ...mapGetters({
      getGoldDetailPrarms: "app/getFinancingDetailPrarms"
    }),
    isShowAgree(){
      return this.fileListOnline.length > 0 || this.fileList.length > 0;
    }
  },
  methods: {
    fileDownload(type){
      this.utils.queryTemplateFile(type)
    },
    ...mapMutations({
      setGoldDetailPrarms: "app/setGoldDetailPrarms"
    }),
    initData() {
      if (this.params) {
        this.tableData =
          (this.getGoldDetailPrarms.requestData &&
            this.getGoldDetailPrarms.requestData.list) ||
          [];
        this.formData =
          (this.getGoldDetailPrarms.requestData &&
            this.getGoldDetailPrarms.requestData.map) ||
          {};
        this.feeData =
          (this.getGoldDetailPrarms && this.getGoldDetailPrarms.feeData) || {};
        this.fatherCheckGold =
          (this.getGoldDetailPrarms && this.getGoldDetailPrarms.info) || {};
        this.fintData = {
          ...this.params.bankChecked,
          ...this.tableData[0],
          ...this.formData,
          ...this.params.applayForm,
          instmRepyTpCd: "5"
        };
        this.goldList = this.fintData.goldList;
        this.tradeBackgroundData = this.params.tradeBackgrounds;
        this.getBindingAccount();
        this.getFile();
        // 设置其他资料的上传参数
        this.relatedFileParam = {
          app: "portal-pc",
          module: "fnc",
          user: this.$store.getters["home/getUserHeader"].realname,
          tblBlId: this.fintData.fncJrnlId,
          mdlId: "fnc",
          atchNm: undefined,
          expdId: undefined //对应哪类的文件
        };

        // 无接口，临时配
        this.relatedFileContents =
          this.dict.relatedFileContents[
            this.dict.bankListMap[this.feeData.bank]
          ] || [];



        console.log(
          "from step2 ",
          this.params,
          this.tableData,
          this.formData,
          this.feeData
        );
      }
    },
    // 查询贸易背景
    getInvContractList() {
      this.invContracLoading = true;
      invoiceList({
        useCase: "financing",
        fncJrnlId: this.fintData.fncJrnlId,
        resultCode: 3
      })
        .then(res => {
          this.tradeBackgroundData = res.data.grid.list || [];
          this.invContracLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.invContracLoading = false;
        });
    },
    // 查看发票
    toInvoiceInfo(record) {
      this.curRow = record;
      this.$refs.invoiceInfo.open();
    },
    contractInfoOpen(data) {
      this.curRow = data;
      this.$refs.contractInfo.open({ });
    },
    // 相关附件上传、编辑、查看
    toDeliveryCreate(record) {
      this.$refs.relatedFileDialog.open({
        invData: record,
        dialogType: "detail"
      });
    },
    // 查看祺信详情
    openGoldDetail(record) {
      this.curRowGold = {
        refresh: true,
        way: "rcvb",
        fromType: 5,
        goldObj: { ...record },
        gldId: record.gldId,
        way: "rcvb"
      };
      this.setGoldDetailPrarms(this.curRowGold);
      this.$refs.finGoldPageDialog.open();
    },
    // 获取绑定提现账户
    getBindingAccount() {
      bindingAccountList({
        accBlngBnk: this.dict.bankList[this.dict.bankListMap[this.feeData.bank]]
          .name,
        checkStCd: 1
      }).then(res => {
        this.bindingAccountData = res.data.grid.list[0] || {};
        this.getFncLawText();
      });
    },
    resetForm() {
      this.$refs.invForm.resetFields();
      this.$refs.contractForm.resetFields();
    },
    showFileList(index) {
      let list = [];
      if (this.fileList[index].file) {
        list = [this.fileList[index].file];
      }
      return list;
    },
    // 查询相关协议
    getFile() {
      if (!this.getGoldDetailPrarms.requestData.mcAgrmtContr) {
        return;
      }
      if (this.dict.bankListMap[this.feeData.bank] != "shanghai") {
        return;
      }
      queryAgreementList({
        bizId: this.getGoldDetailPrarms.requestData.mcAgrmtContr.contractId
      }).then(res => {
        this.fileList = res.data.list;
        this.fileParam.tblBlId = this.getGoldDetailPrarms.requestData.mcAgrmtContr.contractId;
        this.fileDisabled = !res.data.canDel;
        this.$nextTick(() => {
          this.fileList.forEach((i, index) => {
            this.$refs["fncFile"][index].setFileList();
            if (i.file) {
              this.$refs["fncFile"][index].setFileList({
                name: i.file.fileNm,
                size: i.file.fileSize,
                uid: i.file.fileId,
                fileExpdNm: i.file.fileExpdNm,
                fileRte: i.file.fileRte,
                tblBlId: i.file.tblBlId
              });
            }
          });
        });
      });
    },
    // 删除文件
    removeFile(resFileList, file) {
      deleteLawTxtTrans(
        {
          id: file.id
        },
        true
      ).then(res => {
        this.$message.success("删除成功");
      });
    },
    // 相关协议
    uploadOk(resList, artcItem) {
      if (!this.getGoldDetailPrarms.requestData.mcAgrmtContr.contractId) {
        this.$message.error("没有合同id，无法上传");
        return;
      }
      let data = resList[0];
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.getGoldDetailPrarms.requestData.mcAgrmtContr.contractId,
        mdlId: "payable"
      };
      fileSaveAPI(param)
        .then(res => {
          let fileId = res.data.fileId;
          saveOrUpdateBizLawTxtTrans({
            lawTxtType: artcItem.lawTxtType,
            bizId: this.getGoldDetailPrarms.requestData.mcAgrmtContr.contractId,
            fileId: fileId,
            artcTtl: artcItem.artcTtl
          }).then(saveRes => {
            this.getFile();
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取线上签署文档
    getFncLawText() {
      const tradeBacksSelf = this.params.tradeBackgrounds || [];

      const params = {
        lendFormListStr: this.getGoldDetailPrarms.esPrams.lendFormListStr,
        tenantId: this.getGoldDetailPrarms.esPrams.tenantId,
        lmtBusinessInfEntity: this.getGoldDetailPrarms.esPrams
          .lmtBusinessInfEntity,
        formStr: JSON.stringify({
          ...this.formData,
          ...this.feeData,
          instmRepyTpCd: this.fintData.instmRepyTpCd
        }),
        isAutoWithdraw: this.isAutoWithdraw, // 是否自动提现
        withdrawAccountId: this.bindingAccountData.id, // 提现账户的id
        mcAgrmtContr: JSON.stringify(
          this.getGoldDetailPrarms.requestData.mcAgrmtContr
        ),
        bankCd: this.feeData.bank,
        fncJrnlId: this.fintData.fncJrnlId,
        bank: this.feeData.bank,

        tradeBackground: JSON.stringify(tradeBacksSelf),
      };

      getFncLawText(params).then(res => {
        this.fileListOnline = res.data || [];
      });
    },
    // 查看线上的相关协议
    showfileOnline(file) {
      this.$refs.serviceView.open({
        title: file.artcTtl,
        artcCntnt: file.artcCntnt
      });
    },
    // 相关资料
    beforeUploadRelated(fileList, artcItem, index) {
      this.relatedFileParam = {
        app: "portal-pc",
        module: "fnc",
        user: this.$store.getters["home/getUserHeader"].realname,
        tblBlId: this.fintData.fncJrnlId,
        mdlId: "fnc",
        atchNm: artcItem.name,
        fileTpCd: 2,
        fileSubTpCd: artcItem.id,
        expdId: artcItem.id
      };
      this.$nextTick(() => {
        this.$refs["fncRelatedFile"][index].setParams(this.relatedFileParam);
      });
    },
    uploadOkRelated(resList, artcItem) {
      let data = resList[0];
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.fintData.fncJrnlId,
        mdlId: "fnc",
        expdId: artcItem.id,
        atchNm: artcItem.name,
        fileTpCd: 2,
        fileSubTpCd: artcItem.id
      };
      fileSaveAPI(param)
        .then(res => {
          artcItem.fileId = res.data.fileId;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 提交
    submit(btn) {
      let relatedFileNo = this.relatedFileContents.find(
        i => i.required && !i.fileId
      );
      if (relatedFileNo) {
        this.$message.error("请先上传其他资料");
        this.agreeActive = true;
        return;
      }

      if (!this.isAgreeFile && (this.fileList.length > 0 || this.fileListOnline.length > 0)) {
        this.$message.error("请先同意相关协议");
        this.agreeActive = true;
        return;
      }
      let noFile = this.fileList.find(i => !i.file);
      if (noFile) {
        this.$message.error("请上传相关协议");
        return;
      }
      this.agreeActive = false;

      this.modalData = {
        tenantName: this.tableData[0]["goldList"][0].tenantNm,
        applyAmt: this.formData.applyAmt
      };
      this.modalShowPay = true;
    },
    async modalOk(txnPwd) {
      // 先保存贸易背景
      const tradeBacksSelf = this.params.tradeBackgrounds || [];
      await finSaveTradeBackground({
        buryOrgCode: this.params.info && this.params.info.pypt,
        buryName: this.params.info && this.params.info.pyptNm,
        useCase: "financing",
        fncJrnlId: this.tableData[0] && this.tableData[0].fncJrnlId,
        liststr: JSON.stringify(tradeBacksSelf),
        gldId: this.params.info.gldId
      })
        .then(res => {})
        .catch(err => {
          this.modalShowPay = false;
          return;
        });

      if (!this.modalShowPay) {
        return;
      }
      const self = this;
      this.modalShowPay = false;
      const params = {
        txnPwd: txnPwd,
        lendFormListStr: this.getGoldDetailPrarms.esPrams.lendFormListStr,
        tenantId: this.getGoldDetailPrarms.esPrams.tenantId,
        lmtBusinessInfEntity: this.getGoldDetailPrarms.esPrams
          .lmtBusinessInfEntity,
        formStr: JSON.stringify({
          ...this.formData,
          ...this.feeData,
          instmRepyTpCd: this.fintData.instmRepyTpCd
        }),
        isAutoWithdraw: this.isAutoWithdraw, // 是否自动提现
        withdrawAccountId: this.bindingAccountData.id, // 提现账户的id
        mcAgrmtContr: JSON.stringify(
          this.getGoldDetailPrarms.requestData.mcAgrmtContr
        ),
        bankCd: this.feeData.bank,
        tradeBackground: JSON.stringify(tradeBacksSelf),
      };
      submitFormAll(params, true)
        .then(res => {
          this.$success({
            calss: "self-confirm",
            title: "提交成功",
            content: "已提交成功,请等待复核!",
            okText: "确定",
            onOk() {
              self.$emit("success");
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    modalCancel() {
      this.modalShowPay = false;
    }
  },
  created() {
    this.initData();
  },
  watch: {
    params(newVal) {
      this.initData();
    }
  }
};
</script>
<style scoped lang="less">
.text-item-box {
  margin-bottom: 12px;
  .text-item {
    color: #737f8e;
    display: inline-block;
    min-width: 120px;
    text-align: right;
  }
  .fin-num {
    color: #1990ff;
    font-weight: bold;
    font-size: 18px;
  }
  .text-val {
    color: #333333;
  }
}
.file-item {
  .text-color-blue /deep/ .file-list {
    margin-left: 16px;
  }
}
.file-title {
  color: #737f8e;
  line-height: 30px;
  min-width: 430px;
  &.small {
    min-width: 200px;
  }
}
/deep/ .fnc-file {
  display: flex;
  align-items: center;
}
.agree-active {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/gold-financing-steps/gold-financing-step3.vue